import React from 'react';

import { GroupBase } from 'react-select-5';

import { Select } from 'components/shared/SelectRB';
import { TProps as TBaseProps } from 'components/shared/SelectRB/Select/Select';

import { TAdapterType } from './type';

export const withFinalForm = function <
  Option,
  IsMulti extends boolean = false,
  _Group extends GroupBase<Option> = GroupBase<Option>,
>(WrappedComponent: typeof Select) {
  const WithFinalForm = function (props: TBaseProps<Option, IsMulti, _Group> & TAdapterType<Option, IsMulti>) {
    const { input, meta, ...rest } = props;

    return <WrappedComponent isError={meta.error} isFocused={meta.active} {...input} {...rest} />;
  };

  return WithFinalForm;
};
